import _styled, { default as _styled2, default as _styled3 } from "styled-components";
var _templateObject, _templateObject2;
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/web.dom-collections.iterator.js";
import i18next from "i18next";
import { runInAction } from "mobx";
import { observer } from "mobx-react";
import ReactSelect from "react-select";
import ReactSelectCreatable from "react-select/creatable";
import { useTheme } from "styled-components";
import isDefined from "../../Core/isDefined";
import CommonStrata from "../../Models/Definition/CommonStrata";
import { jsx as _jsx } from "react/jsx-runtime";
export const SelectableDimensionEnum = observer(_ref => {
  var _dim$undefinedLabel, _dim$options, _options;
  let {
    dim
  } = _ref;
  const theme = useTheme();
  const undefinedOption = {
    value: undefined,
    label: (_dim$undefinedLabel = dim.undefinedLabel) !== null && _dim$undefinedLabel !== void 0 ? _dim$undefinedLabel : i18next.t("selectableDimensions.undefinedLabel")
  };
  let options = (_dim$options = dim.options) === null || _dim$options === void 0 ? void 0 : _dim$options.map(option => {
    var _option$name;
    return {
      value: option.id,
      label: (_option$name = option.name) !== null && _option$name !== void 0 ? _option$name : option.id
    };
  });
  const selectedOption = dim.selectedId ? (_options = options) === null || _options === void 0 ? void 0 : _options.find(option => option.value === dim.selectedId) : undefinedOption;
  if (!options) return null;
  if (typeof dim.selectedId === "undefined" || dim.allowUndefined) {
    options = [undefinedOption, ...options];
  }
  return dim.allowCustomInput ? /*#__PURE__*/_jsx(_StyledReactSelectCreatable, {
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: theme.darkLighter
      }),
      option: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        color: "white"
      })
    },
    options: options,
    value: selectedOption,
    onChange: evt => {
      runInAction(() => {
        var _evt$value;
        return dim.setDimensionValue(CommonStrata.user, (_evt$value = evt === null || evt === void 0 ? void 0 : evt.value) !== null && _evt$value !== void 0 ? _evt$value : "");
      });
    },
    isClearable: dim.allowUndefined,
    formatOptionLabel: dim.optionRenderer,
    theme: selectTheme => _objectSpread(_objectSpread({}, selectTheme), {}, {
      colors: _objectSpread(_objectSpread({}, selectTheme.colors), {}, {
        neutral0: theme.darkLighter,
        neutral10: theme.grey,
        neutral20: theme.grey,
        neutral80: "white",
        primary25: theme.grey,
        primary50: theme.colorPrimary,
        primary75: theme.colorPrimary,
        primary: theme.colorPrimary
      })
    })
  }) : /*#__PURE__*/_jsx(_StyledReactSelect, {
    styles: {
      control: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        borderColor: theme.darkLighter
      }),
      option: baseStyles => _objectSpread(_objectSpread({}, baseStyles), {}, {
        color: "white"
      })
    },
    options: options,
    value: selectedOption,
    onChange: evt => {
      runInAction(() => {
        var _evt$value2;
        return dim.setDimensionValue(CommonStrata.user, (_evt$value2 = evt === null || evt === void 0 ? void 0 : evt.value) !== null && _evt$value2 !== void 0 ? _evt$value2 : "");
      });
    },
    isClearable: dim.allowUndefined,
    formatOptionLabel: dim.optionRenderer,
    theme: selectTheme => _objectSpread(_objectSpread({}, selectTheme), {}, {
      colors: _objectSpread(_objectSpread({}, selectTheme.colors), {}, {
        neutral0: theme.darkLighter,
        neutral10: theme.grey,
        neutral20: theme.grey,
        neutral80: "white",
        primary25: theme.grey,
        primary50: theme.colorPrimary,
        primary75: theme.colorPrimary,
        primary: theme.colorPrimary
      })
    })
  });
});

/** Similar to SelectableDimensionEnum, but allows multiple values to be selected */
export const SelectableDimensionEnumMulti = observer(_ref2 => {
  var _dim$options2;
  let {
    dim
  } = _ref2;
  const theme = useTheme();
  const options = (_dim$options2 = dim.options) === null || _dim$options2 === void 0 ? void 0 : _dim$options2.map(option => {
    var _option$name2;
    return {
      value: option.id,
      label: (_option$name2 = option.name) !== null && _option$name2 !== void 0 ? _option$name2 : option.id
    };
  });
  if (!options) return null;
  const selectedOptions = options.filter(option => {
    var _dim$selectedIds;
    return (_dim$selectedIds = dim.selectedIds) === null || _dim$selectedIds === void 0 ? void 0 : _dim$selectedIds.some(id => option.value === id);
  });
  return /*#__PURE__*/_jsx(_StyledReactSelect2, {
    options: options,
    value: selectedOptions,
    onChange: evt => {
      runInAction(() => {
        var _evt$map$filter;
        return dim.setDimensionValue(CommonStrata.user, (_evt$map$filter = evt === null || evt === void 0 ? void 0 : evt.map(selected => selected.value).filter(isDefined)) !== null && _evt$map$filter !== void 0 ? _evt$map$filter : []);
      });
    },
    isClearable: dim.allowUndefined,
    formatOptionLabel: dim.optionRenderer,
    theme: selectTheme => _objectSpread(_objectSpread({}, selectTheme), {}, {
      colors: _objectSpread(_objectSpread({}, selectTheme.colors), {}, {
        primary25: theme.greyLighter,
        primary50: theme.colorPrimary,
        primary75: theme.colorPrimary,
        primary: theme.colorPrimary
      })
    }),
    isMulti: true,
    $_css: theme.dark
  });
});
var _StyledReactSelectCreatable = _styled(ReactSelectCreatable)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n        color: white;\n      "])));
var _StyledReactSelect = _styled2(ReactSelect)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n        color: white;\n      "])));
var _StyledReactSelect2 = _styled3(ReactSelect).withConfig({
  displayName: "Select___StyledReactSelect2",
  componentId: "sc-fg2h66-0"
})(["color:", ";border:none;"], p => p.$_css);